<template>
	<div class="switch">
		<div class="onoffswitch">
			<input type="checkbox" :name="switchName" class="onoffswitch-checkbox" :id="switchName" v-model="checked" v-on:change="checkChange">
			<label class="onoffswitch-label" :for="switchName">
                    <span class="onoffswitch-inner"></span>
                    <span class="onoffswitch-switch"></span>
            </label>
		</div>
	</div>
</template>
<script>
export default {
  name: 'SwitchBox',
  props:['switchName'],
  data () {
    return {
    	checked:false
    }
  },
  methods:{
  	checkChange:function () {
  		this.$emit('checkChange',this.checked)
  	}
  }
}
</script>

<style scoped>
/* TOOGLE SWICH */

.onoffswitch {
    position: relative;
    width: 64px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.onoffswitch-checkbox {
    display: none;
}

.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid #1ab394;
    border-radius: 2px;
}

.onoffswitch-inner {
    width: 200%;
    margin-left: -100%;
    -webkit-transition: margin 0.3s ease-in 0s;
    transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before,
.onoffswitch-inner:after {
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}

.onoffswitch-inner:before {
    content: "ON";
    padding-left: 10px;
    background-color: #1ab394;
    color: #FFFFFF;
}

.onoffswitch-inner:after {
    content: "OFF";
    padding-right: 10px;
    background-color: #FFFFFF;
    color: #999999;
    text-align: right;
}

.onoffswitch-switch {
    width: 20px;
    margin: 0px;
    background: #FFFFFF;
    border: 2px solid #1ab394;
    border-radius: 2px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 44px;
    -webkit-transition: all 0.3s ease-in 0s;
    transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
</style>


// WEBPACK FOOTER //
// SwitchBox.vue?df0598b8